module.exports = __webpack_public_path__ + "img/huawei.73a6b198.png";